/**
 * Muria standalone configurator page.
 * URL: /pages/configurateur?product=HANDLE&material=rebel-mattic
 *
 * Flow:
 * 1. Read product handle + material from URL
 * 2. Fetch product data via Section Rendering API (includes metafields)
 * 3. Show wallpaper in Cropper.js
 * 4. On "Commander": call Muria API inline, add to cart, redirect to /cart
 *    (no intermediate loading page)
 */

(function () {
  'use strict';

  var PAPER_TYPES = {
    'premium':       { label: 'Premium Muria\u2122', desc: 'Encollage du mur \u00b7 Intiss\u00e9 \u00b7 Surface mate', surcharge: 0, price: 31 },
    'adhesif':       { label: 'Adh\u00e9sif Muria\u2122', desc: 'Auto-adh\u00e9sif \u00b7 Repositionnable \u00b7 Sans colle', surcharge: 18, price: 49 },
  
  };
  // Map old keys from product page URL to new keys
  var KEY_ALIASES = { 'rebel-mattic': 'premium', 'peel-stick': 'adhesif', 'commercial': 'professionnel' };

  var API_URL = 'https://api.ateliermuria.com/';

  // URL params
  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('product');
  var rawMaterial = params.get('material') || 'premium';
  var initialMaterial = KEY_ALIASES[rawMaterial] || rawMaterial;

  if (!productHandle) {
    document.getElementById('configurator-app').innerHTML = '<p style="text-align:center;padding:60px 20px;color:#6B6B6B;">Aucun produit s\u00e9lectionn\u00e9. <a href="/" style="color:#2B2B2B;text-decoration:underline;">Retour</a></p>';
    return;
  }

  // State
  var product = null;
  var basePrice = 0;
  var productTitle = '';
  var commercialName = '';
  var designPapierUrl = '';
  var productId = '';
  var productReference = '';
  var cropperInstance = null;
  var selectedMaterial = initialMaterial;

  // DOM refs
  var elImage, elWidth, elHeight, elPrice, elButton, elError, elTopBar, elRightBar, elBox, elRowMain, elSection, elTable, elPanels, elPanelsBtn;
  var panelsOn = false;
  var PANEL_WIDTH_CM = 50; // wallpaper panel (lé) width

  // --- Load product data via Section Rendering API ---
  async function loadProduct() {
    try {
      // Fetch section that has product context (resolves metafields)
      var sectionResp = await fetch('/products/' + productHandle + '?section_id=configurator-meta');
      if (!sectionResp.ok) throw new Error('Section fetch failed');
      var sectionHtml = await sectionResp.text();

      // Parse the HTML to extract data attributes
      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionHtml, 'text/html');
      var meta = doc.getElementById('cfg-meta-output');

      if (meta) {
        designPapierUrl = meta.dataset.designPapier || '';
        productId = meta.dataset.productId || '';
        basePrice = parseFloat(meta.dataset.basePrice || '0') / 100; // Shopify prices in cents
        productTitle = meta.dataset.productTitle || '';
        commercialName = meta.dataset.commercialName || '';
      }

      // Also fetch basic product data for images fallback
      var prodResp = await fetch('/products/' + productHandle + '.json');
      if (prodResp.ok) {
        var prodData = await prodResp.json();
        product = prodData.product;
        if (!productTitle) productTitle = product.title;
        if (!productId) productId = product.id;
        if (!basePrice && product.variants && product.variants.length) {
          basePrice = parseFloat(product.variants[0].price);
        }
        // Extract AM reference (format: AM{YY}{#####}) from tags
        var tags = product.tags || [];
        if (typeof tags === 'string') tags = tags.split(',').map(function(t){ return t.trim(); });
        for (var i = 0; i < tags.length; i++) {
          if (/^AM\d{2}\d{5}$/.test(tags[i])) { productReference = tags[i]; break; }
        }
      }

      renderConfigurator();
      initCropper();
    } catch (e) {
      document.getElementById('configurator-app').innerHTML = '<p style="text-align:center;padding:60px 20px;color:#b00020;">Produit introuvable : ' + productHandle + '</p>';
      console.error(e);
    }
  }

  // --- Render ---
  function renderConfigurator() {
    var imageUrl = designPapierUrl;
    if (!imageUrl && product && product.images && product.images.length) {
      imageUrl = product.images[0].src;
    }
    if (!imageUrl) {
      imageUrl = 'https://placehold.co/1200x800/f7f5f2/ccc?text=Aucune+image';
    }

    var paperBtns = '';
    for (var key in PAPER_TYPES) {
      var type = PAPER_TYPES[key];
      var active = key === selectedMaterial ? ' active' : '';
      paperBtns += '<label class="cfg-paper-option' + active + '">'
        + '<input type="radio" name="paper-type" value="' + key + '" data-surcharge="' + type.surcharge + '" data-label="' + type.label + '"' + (active ? ' checked' : '') + '>'
        + '<div class="cfg-paper-row"><strong>' + type.label + '</strong><span class="cfg-paper-price">' + type.price + ' \u20ac/m\u00b2</span></div>'
        + '<span class="cfg-paper-desc">' + type.desc + '</span>'
        + '</label>';
    }

    var displayName = commercialName || productTitle || 'Papier peint';

    var app = document.getElementById('configurator-app');
    app.innerHTML = ''
      // Header: floating circular back button + centered title
      + '<a href="/products/' + productHandle + '" class="cfg-back" aria-label="Retour au produit">'
      + '  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      + '</a>'
      + '<div class="cfg-header">'
      + '  <button type="button" id="cfg-panels-toggle" class="cfg-panels-pill" aria-pressed="false">'
      + '    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 4v16M12 4v16M18 4v16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
      + '    <span>Voir les l\u00e9s</span>'
      + '  </button>'
      + '</div>'
      // Cropper: container fills the section; crop box is a sub-rectangle with
      // padding; bars are absolute overlays anchored to the crop box edges.
      + '<div class="cfg-cropper-section">'
      + '  <div class="cfg-cropper-box"><img id="cfg-image" src="' + imageUrl + '" crossorigin="anonymous" alt="' + displayName + '"></div>'
      + '  <div id="cfg-top-bar" class="cfg-bar-h"></div>'
      + '  <div id="cfg-right-bar" class="cfg-bar-v"></div>'
      + '  <div id="cfg-panels" class="cfg-panels" aria-hidden="true"></div>'
      + '</div>'
      // Hint sits above the cards, out of the cropper/image area
      + '<div class="cfg-crop-hint">'
      + '  <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 3v18M3 12h18M12 3l-3 3M12 3l3 3M12 21l-3-3M12 21l3-3M3 12l3-3M3 12l3 3M21 12l-3-3M21 12l-3 3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      + '  <span>Glisser pour recadrer</span>'
      + '</div>'
      // Horizontal controls bar
      + '<div class="cfg-controls">'
      + '  <div class="cfg-ctrl-section">'
      + '    <div class="cfg-ctrl-label">Dimensions du mur</div>'
      + '    <div class="cfg-size-inputs">'
      + '      <div class="cfg-input-group">'
      + '        <label>Largeur</label>'
      + '        <div class="cfg-input-wrap"><input type="number" id="cfg-width" value="300" min="50" max="6000" step="1"><span class="cfg-unit">cm</span></div>'
      + '      </div>'
      + '      <div class="cfg-input-group">'
      + '        <label>Hauteur</label>'
      + '        <div class="cfg-input-wrap"><input type="number" id="cfg-height" value="250" min="50" max="4000" step="1"><span class="cfg-unit">cm</span></div>'
      + '      </div>'
      + '    </div>'
      + '    <div class="cfg-size-note">Ajoutez 10 cm de marge \u00e0 vos mesures pour s\u00e9curiser la pose.</div>'
      + '    <button type="button" id="cfg-flip" class="cfg-pill-btn" aria-pressed="false">'
      + '      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M4 7h7v10H4zM13 7h7v10h-7zM13 4v3M13 17v3M13 10h2M13 12h2M13 14h2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      + '      <span>Miroir</span>'
      + '    </button>'
      + '  </div>'
      + '  <div class="cfg-ctrl-section">'
      + '    <div class="cfg-ctrl-label">Type de papier peint</div>'
      + '    <div class="cfg-paper-types">' + paperBtns + '</div>'
      + '  </div>'
      + '  <div class="cfg-ctrl-section cfg-cta-section">'
      + '    <div class="cfg-total-row">'
      + '      <span class="cfg-total-label" id="cfg-total-label">Prix</span>'
      + '      <span class="cfg-total-price" id="cfg-price">--</span>'
      + '    </div>'
      + '    <div id="cfg-error" class="cfg-error"></div>'
      + '    <button type="button" id="cfg-order-btn" class="button button-solid add_to_cart_button w-full cfg-order-btn" disabled>'
      + '      <span class="flex justify-center items-center">'
      + '        <span class="x-atc-text button-text" id="cfg-btn-text">Valider ma personnalisation</span>'
      + '        <span class="button-icon opacity-0 w-5 -translate-x-[4px]">'
      + '          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" style="fill:none" aria-hidden="true">'
      + '            <path d="M4.25 9.49927H14.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
      + '            <path d="M9.5 4.24927L14.75 9.49927L9.5 14.7493" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
      + '          </svg>'
      + '        </span>'
      + '      </span>'
      + '      <span id="cfg-btn-spinner" style="display:none;" class="cfg-spinner"></span>'
      + '    </button>'
      + '    <div id="cfg-payments-slot"></div>'
      + '    <ul class="cfg-reassurance">'
      + '      <li id="cfg-delivery"></li>'
      + '      <li>Livraison à votre domicile offerte</li>'
      + '      <li>Garantie sérénité incluse</li>'
      + '    </ul>'
      + '  </div>'
      + '</div>';

    // Bind refs
    elImage = document.getElementById('cfg-image');
    elWidth = document.getElementById('cfg-width');
    elHeight = document.getElementById('cfg-height');
    elPrice = document.getElementById('cfg-price');
    elButton = document.getElementById('cfg-order-btn');
    elError = document.getElementById('cfg-error');
    elTopBar = document.getElementById('cfg-top-bar');
    elRightBar = document.getElementById('cfg-right-bar');
    elBox = document.querySelector('.cfg-cropper-box');
    elRowMain = document.querySelector('.cfg-row-main');
    elSection = document.querySelector('.cfg-cropper-section');
    elTable = document.querySelector('.cfg-cropper-table');
    elPanels = document.getElementById('cfg-panels');
    elPanelsBtn = document.getElementById('cfg-panels-toggle');

    // Events
    elWidth.addEventListener('input', updatePrice);
    elHeight.addEventListener('input', updatePrice);
    document.querySelectorAll('input[name="paper-type"]').forEach(function (el) {
      el.addEventListener('change', function () {
        selectedMaterial = this.value;
        document.querySelectorAll('.cfg-paper-option').forEach(function (o) { o.classList.remove('active'); });
        this.closest('.cfg-paper-option').classList.add('active');
        updatePriceOnly();
      });
    });
    var flipBtn = document.getElementById('cfg-flip');
    flipBtn.addEventListener('click', function () {
      var on = flipBtn.getAttribute('aria-pressed') === 'true';
      var next = !on;
      flipBtn.setAttribute('aria-pressed', next ? 'true' : 'false');
      flipBtn.classList.toggle('active', next);
      if (cropperInstance) cropperInstance.scaleX(next ? -1 : 1);
    });
    elButton.addEventListener('click', handleOrder);

    elPanelsBtn.addEventListener('click', function () {
      panelsOn = !panelsOn;
      elPanelsBtn.setAttribute('aria-pressed', panelsOn ? 'true' : 'false');
      elPanelsBtn.classList.toggle('active', panelsOn);
      elPanels.setAttribute('aria-hidden', panelsOn ? 'false' : 'true');
      updatePanels();
    });

    // Inject the server-rendered Shopify payment icons (see page.configurateur.json).
    var paymentsTpl = document.getElementById('cfg-payments-template');
    var paymentsSlot = document.getElementById('cfg-payments-slot');
    if (paymentsTpl && paymentsSlot) {
      paymentsSlot.innerHTML = paymentsTpl.innerHTML;
    }

    updateDeliveryText();
  }

  // --- Cropper ---
  function buildCropper(onReady) {
    cropperInstance = new Cropper(elImage, {
      autoCropArea: 1,
      viewMode: 1,            // crop box stays inside canvas → natural axis-lock on the filled axis
      movable: true,          // image can be dragged
      zoomable: false,
      zoomOnTouch: false,
      zoomOnWheel: false,
      restore: false,
      rotatable: false,
      scalable: true,
      dragMode: 'move',       // drag moves the image behind the crop box
      modal: true,
      responsive: false,      // we drive reflow ourselves (debounced) on resize
      cropBoxResizable: false,
      cropBoxMovable: false,  // crop box stays FIXED
      ready: function () {
        if (typeof onReady === 'function') onReady();
      }
    });
  }

  function initCropper() {
    function boot() {
      if (typeof Cropper === 'undefined') { setTimeout(boot, 100); return; }
      fitBoxToRatio();
      buildCropper(function () {
        applyCropBoxFromDims();
        updateBars();
        elButton.disabled = false;
        updatePriceOnly();
      });
    }
    boot();
  }

  // Stub — container now fills the section; no box resizing is needed.
  function fitBoxToRatio() { /* no-op */ }

  // Pin the crop box to one full axis of the container so drag is naturally
  // locked to the other axis by viewMode:1:
  //   - container wider than wall → crop box fills full height → horizontal drag only
  //   - container taller than wall → crop box fills full width → vertical drag only
  // Bar strips (22px top, 24px right) are reserved via CSS padding on cropper-box
  // so the cropper's container *is* the exact drag surface — no slack along the
  // pinned axis. Dimmed image remains visible on the unpinned sides.
  function applyCropBoxFromDims() {
    if (!cropperInstance) return;
    var w = parseFloat(elWidth.value), h = parseFloat(elHeight.value);
    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return;
    cropperInstance.setAspectRatio(w / h);
    var cd = cropperInstance.getContainerData();
    if (cd.width <= 0 || cd.height <= 0) return;

    var ratio = w / h;
    var boxW, boxH, left, top;
    if (cd.width / cd.height > ratio) {
      boxH = cd.height;
      boxW = boxH * ratio;
      left = (cd.width - boxW) / 2;
      top = 0;
    } else {
      boxW = cd.width;
      boxH = boxW / ratio;
      left = 0;
      top = (cd.height - boxH) / 2;
    }
    cropperInstance.setCropBoxData({ left: left, top: top, width: boxW, height: boxH });
  }

  function updateBars() {
    if (!cropperInstance || !elTopBar || !elRightBar || !elBox) return;
    var cbd = cropperInstance.getCropBoxData();
    // cbd is relative to the cropper container (= cropper-box). Translate into
    // section coords by adding cropper-box's own offset inside the section.
    var boxLeft = elBox.offsetLeft; // 0 (CSS left: 0)
    var boxTop = elBox.offsetTop;   // 22 (CSS top: 22px)
    var BAR_H = 22;
    elTopBar.style.left = (cbd.left + boxLeft) + 'px';
    elTopBar.style.top = (cbd.top + boxTop - BAR_H) + 'px';
    elTopBar.style.width = cbd.width + 'px';
    elTopBar.textContent = elWidth.value + ' cm';
    elRightBar.style.left = (cbd.left + cbd.width + boxLeft) + 'px';
    elRightBar.style.top = (cbd.top + boxTop) + 'px';
    elRightBar.style.height = cbd.height + 'px';
    elRightBar.innerHTML = '<div class="cfg-bar-v-text">' + elHeight.value + ' cm</div>';
    updatePanels();
  }

  // Render vertical lines every PANEL_WIDTH_CM (50cm) inside the crop box,
  // starting from its left edge, to preview the wallpaper strips (lés).
  function updatePanels() {
    if (!elPanels || !cropperInstance) return;
    elPanels.innerHTML = '';
    if (!panelsOn) { elPanels.style.display = 'none'; return; }
    var w = parseFloat(elWidth.value);
    if (isNaN(w) || w <= 0) { elPanels.style.display = 'none'; return; }
    var cbd = cropperInstance.getCropBoxData();
    var boxLeft = elBox.offsetLeft;
    var boxTop = elBox.offsetTop;
    elPanels.style.display = 'block';
    elPanels.style.left = (cbd.left + boxLeft) + 'px';
    elPanels.style.top = (cbd.top + boxTop) + 'px';
    elPanels.style.width = cbd.width + 'px';
    elPanels.style.height = cbd.height + 'px';
    var pxPerCm = cbd.width / w;
    var nPanels = Math.ceil(w / PANEL_WIDTH_CM);
    for (var i = 1; i < nPanels; i++) {
      var x = i * PANEL_WIDTH_CM * pxPerCm;
      if (x >= cbd.width) break;
      var line = document.createElement('div');
      line.className = 'cfg-panel-line';
      line.style.left = x + 'px';
      elPanels.appendChild(line);
    }
  }

  // --- Price ---
  function getSelectedPaper() {
    var el = document.querySelector('input[name="paper-type"]:checked');
    if (!el) return PAPER_TYPES['premium'];
    return PAPER_TYPES[el.value] || PAPER_TYPES['premium'];
  }

  function updatePrice() {
    if (!cropperInstance) return;
    var w = parseFloat(elWidth.value), h = parseFloat(elHeight.value);
    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return;

    // Preserve mirror state across rebuild
    var mirrored = false;
    try { mirrored = cropperInstance.getData().scaleX < 0; } catch (e) {}

    // Resize the cropper box to the new aspect ratio, then rebuild the cropper
    // so its canvas fills the new container perfectly (no whitespace gap).
    fitBoxToRatio();
    cropperInstance.destroy();
    cropperInstance = null;

    buildCropper(function () {
      applyCropBoxFromDims();
      if (mirrored) cropperInstance.scaleX(-1);
      updateBars();
    });

    updatePriceOnly();
  }

  function updatePriceOnly() {
    var w = parseFloat(elWidth.value), h = parseFloat(elHeight.value);
    var paper = getSelectedPaper();
    var currentBase = basePrice + paper.surcharge;
    if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0) {
      var area = (w / 100) * (h / 100);
      elPrice.textContent = (currentBase * area).toFixed(2) + ' \u20ac TTC';
      var label = document.getElementById('cfg-total-label');
      if (label) label.textContent = 'Prix pour ' + area.toFixed(2) + ' m\u00b2';
    }
  }

  // Delivery window text: today + 4 to today + 5, skipping Sundays.
  // Example: "Commandez aujourd\u2019hui, recevez entre le 24/04 et le 26/04"
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // skip Sundays
    }
    return d;
  }
  function formatDM(d) {
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    return dd + '/' + mm;
  }
  function updateDeliveryText() {
    var el = document.getElementById('cfg-delivery');
    if (!el) return;
    var today = new Date();
    var from = addBusinessDays(today, 4);
    var to = addBusinessDays(today, 5);
    el.textContent = 'Commandez aujourd\u2019hui, recevez entre le ' + formatDM(from) + ' et le ' + formatDM(to);
  }

  // --- Order: inline API call + add to cart (NO loading page) ---
  async function handleOrder() {
    elError.textContent = '';
    elError.style.display = 'none';

    var w = parseFloat(elWidth.value), h = parseFloat(elHeight.value);
    if (!w || !h) { showError('Veuillez renseigner les dimensions.'); return; }
    if (w < 100 || w > 6000) { showError('Largeur : entre 100 cm et 6 m\u00e8tres.'); return; }
    if (h < 100 || h > 4000) { showError('Hauteur : entre 100 cm et 4 m\u00e8tres.'); return; }
    if (!cropperInstance) { showError('Configurateur pas encore pr\u00eat.'); return; }

    var cropData = cropperInstance.getData();
    var reverseMode = document.getElementById('cfg-flip').getAttribute('aria-pressed') === 'true';
    var paper = getSelectedPaper();
    var materialKey = (document.querySelector('input[name="paper-type"]:checked') || {}).value || 'rebel-mattic';

    // Show spinner
    setButtonLoading(true);

    try {
      // Build FormData for API
      var fd = new FormData();
      fd.append('origin_url', elImage.src);
      fd.append('product_id', productId);
      fd.append('width', w);
      fd.append('height', h);
      fd.append('paper_type', materialKey);
      fd.append('reverse_mode', reverseMode);
      fd.append('crop_box[x]', cropData.x);
      fd.append('crop_box[y]', cropData.y);
      fd.append('crop_box[width]', cropData.width);
      fd.append('crop_box[height]', cropData.height);

      // Call API
      var resp = await fetch(API_URL, { method: 'POST', body: fd });
      var result = await resp.json();

      if (result.status !== 'success') {
        // Retry once
        fd.append('retry', 'true');
        resp = await fetch(API_URL, { method: 'POST', body: fd });
        result = await resp.json();
      }

      if (result.status !== 'success') {
        throw new Error(result.message || 'Erreur lors de la cr\u00e9ation.');
      }

      // Build cart properties
      var props = {
        'R\u00e9f\u00e9rence': productReference,
        'Type de papier': paper.label,
        'Type d\u2019impression': 'sur mesure',
        'Largeur': w + ' cm',
        'Hauteur': h + ' cm' + (reverseMode ? ' (miroir)' : ''),
        'Aper\u00e7u': result.image,
        '_product_title': productTitle,
        '_product_price': result.product_price
      };

      // Wait for Shopify to propagate the new variant to the storefront
      await new Promise(function(r) { setTimeout(r, 3000); });

      // Add to cart
      var cartBody = JSON.stringify({ id: result.product_id, quantity: 1, properties: props });
      var cartHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      var cartResp = await fetch('/cart/add.json', { method: 'POST', headers: cartHeaders, body: cartBody });

      if (!cartResp.ok) {
        var cartErr = await cartResp.json().catch(function() { return {}; });
        var errMsg = (cartErr.description || cartErr.errors || '').toString();

        // If error is "plus en stock" it means the cart has stale variants blocking the add.
        // Clear those stale items and retry.
        if (errMsg.indexOf('stock') !== -1 || cartResp.status === 422) {
          console.warn('Cart has stale items, clearing and retrying...');
          // Get current cart, remove items that aren't the one we're adding
          var currentCart = await (await fetch('/cart.json')).json();
          var updates = {};
          (currentCart.items || []).forEach(function(item) {
            // Set all existing items to 0 (clear them) — they are test/stale variants
            // In production, you may want to only remove items from this product
            if (item.product_id === parseInt(productId)) {
              updates[item.key] = 0;
            }
          });
          if (Object.keys(updates).length > 0) {
            await fetch('/cart/update.json', {
              method: 'POST',
              headers: cartHeaders,
              body: JSON.stringify({ updates: updates })
            });
          }
          // Retry add
          await new Promise(function(r) { setTimeout(r, 500); });
          cartResp = await fetch('/cart/add.json', { method: 'POST', headers: cartHeaders, body: cartBody });
        }
      }

      if (!cartResp.ok) {
        var cartErr2 = await cartResp.json().catch(function() { return {}; });
        console.error('Cart add failed after retry:', cartResp.status, cartErr2);
        throw new Error('Erreur ajout au panier. Essayez de vider votre panier et recommencer.');
      }

      // Redirect to cart
      window.location.href = '/cart';

    } catch (e) {
      console.error('Order error:', e);
      showError('Un probl\u00e8me est survenu. R\u00e9essayez ou contactez contact@ateliermuria.com');
      setButtonLoading(false);
    }
  }

  function setButtonLoading(loading) {
    var text = document.getElementById('cfg-btn-text');
    var spinner = document.getElementById('cfg-btn-spinner');
    if (loading) {
      text.textContent = 'Cr\u00e9ation en cours\u2026';
      spinner.style.display = 'inline-block';
      elButton.disabled = true;
    } else {
      text.textContent = 'Commander mon papier peint';
      spinner.style.display = 'none';
      elButton.disabled = false;
    }
  }

  function showError(msg) {
    elError.textContent = msg;
    elError.style.display = 'block';
  }

  // --- Resize: reflow cropper to new container size ---
  // Debounced; on mobile we ignore pure-height changes (keyboard, URL-bar) by
  // only reacting when the viewport width actually changed.
  var resizeTimer = null;
  var lastViewportWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    // Vertical-only changes (e.g. mobile URL bar show/hide, window height drag) don't
    // require a cropper rebuild — only react when the viewport width actually changes.
    if (window.innerWidth === lastViewportWidth) return;
    lastViewportWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (cropperInstance) updatePrice();
    }, 180);
  });

  // --- Init ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadProduct);
  } else {
    loadProduct();
  }
})();
